<div [hidden]="!showAtecoEditForm" [ngClass]="{ 'p-24': true, 'mb-16': showAtecoEditForm }" class="mat-elevation-z2">
    <ng-container *ngIf="ateco">
        <form fxLayout="column" [formGroup]="atecoEditForm">
            <div class="w-100-p" style="overflow-x: hidden" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px">
                <div class="detail-container">
                    <span class="detail-label border-bottom">Ateco Id</span>
                    <span class="detail-value">{{ atecoForEditing.atecoid }}</span>
                </div>
                <div class="detail-container">
                    <span class="detail-label border-bottom">Descrizione</span>
                    <span class="detail-value">{{ descrizioneOriginaleAteco }}</span>
                </div>
            </div>
            <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
                <mat-form-field class="w-50-p">
                    <input matInput required [matDatepicker]="pickerInizio" placeholder="Data inizio attività" id="dataInizio" formControlName="dataInizio" />
                    <mat-error *ngIf="atecoEditForm.get('dataInizio').hasError('required')"> Data inizio attività richiesta </mat-error>
                    <mat-datepicker-toggle matSuffix [for]="pickerInizio"></mat-datepicker-toggle>

                    <mat-datepicker #pickerInizio></mat-datepicker>
                </mat-form-field>
                <mat-form-field class="w-50-p">
                    <input matInput [matDatepicker]="pickerFine" placeholder="Data fine attività" id="dataFine" formControlName="dataFine" />
                    <mat-datepicker-toggle matSuffix [for]="pickerFine"></mat-datepicker-toggle>

                    <mat-datepicker #pickerFine></mat-datepicker>
                </mat-form-field>
            </div>

            <mat-form-field>
                <input matInput id="note" formControlName="descrizionePersonalizzata" placeholder="Descrizione Personalizzata" />
            </mat-form-field>
            <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="12px">
                <button mat-button color="primary" type="button" (click)="annullaAteco()">Annulla</button>
                <button mat-button color="primary" (click)="saveAteco()" [disabled]="atecoEditForm?.invalid || atecoEditForm?.pristine" type="button">
                    Salva
                </button>
            </div>
        </form>
    </ng-container>
</div>
